import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export function ProgereVersionBadge({ moduleName = "CORE", onClick }) {
  const [version, setVersion] = useState(null);
  useEffect(() => {
    api.get("/releases/current").then(({ data }) => setVersion(data.version)).catch(() => {});
  }, []);
  return (
    <Link
      to="/nouveautes"
      onClick={onClick}
      data-testid="sidebar-version-badge"
      className="mx-3 mb-4 flex items-center justify-between rounded-lg border border-white/8 bg-white/5 px-3.5 py-2.5 text-left hover:border-[#EAB308]/40 transition-colors"
    >
      <div>
        <div className="text-[11px] font-bold text-white/70">PROGÈRE {moduleName}</div>
        <div className="text-[10px] font-mono text-white/40">Version {version || "…"}</div>
      </div>
      <span className="text-[9px] font-black uppercase tracking-wider text-[#EAB308]">Nouveautés</span>
    </Link>
  );
}
